module.exports = __webpack_public_path__ + "img/Maker_Trophy.e2da9bc5.svg";